export const editColorModal = {
  extend: '/add-color-modal',
  ModalHeader: {
    title: 'Edit "{{ key }}" color'
  },
  Flex: {},
  ModalFooter: {
    props: {
      gap: 'A'
    },
    CheckButton: {
      icon: 'checkmark',
      text: '{{ common.action.save | polyglot }}'
    },
    'IconButton.copy': {
      extends: ['Link', 'IconButton'],
      margin: '- - - auto',
      icon: 'copy outline',
      href: (el, s) => '/color/add-color/' + s.value
    },
    'IconButton.trash': {
      if: (el, s) => el.getDesignSystem('color')[s.key],
      icon: 'trash outline',
      onClick: (ev, el, s) => {
        const { key } = s
        const text = 'Do you want to remove the color?'
        if (key && window.confirm(text)) {
          const color = el.getDesignSystem('color')
          delete color[key]
          el.getRootState().update({
            designSystem: {
              color
            }
          })
          el.call('closeRouterModal', el, s)
        }
      }
    }
  },
  props: {
    onInit: (el, s) => {
      const path = window.location.pathname
      const pathArray = path.split('edit-color/')
      // `getDesignSystem('color')` already merges builtins (`getBuiltins()`)
      // UNDER the project's own saved color table (see
      // methods/design-system.js), so `color[key]` alone covers both a
      // project-defined color AND a built-in one — no separate fallback
      // read is needed. The removed `el.getRootState().DEFAULT_DESIGN_SYSTEM`
      // fallback was dead AND crash-prone: that root-state key is never set
      // anywhere in current source (same defect class fixed in
      // workspace/packages/design-system's ColorPalleteSection/
      // GradientsSection/SemanticColorsSection/ThemesSection, CAT-3), so it
      // would have thrown `Cannot read properties of undefined` the moment
      // `color[key]` was ever falsy.
      const color = el.getDesignSystem('color')
      if (!color) return
      const key = pathArray[1]
      const value = color[key]
      if (!key || !value) return
      s.update(
        {
          key,
          value: value || key
        },
        {
          preventUpdate: true,
          preventContentUpdate: true
        }
      )
    }
  }
}
